import React, { useState } from "react";
import ReactModal from "react-modal";
import { Input,DateInput, Draggable, Select, Pagination } from "@components";
import { FormProvider } from "react-hook-form";
import { useDeptList } from "@hooks";

function SearchUserModal({ isOpen, onClose, onConfirm, }) {

  const position = Draggable({
    isOpen,
    dragHandle: ".modal-header",
  });

  const containerStyle = {
    maxWidth: "1300px",
    minWidth: "1300px",
    maxHeight: "650px",
    minHeight: "650px",
    transform: `translate(-50%, -50%) translate(${position.x}px, ${position.y}px)`
  };

  const {
    methods,
    data,
    handleSubmit, 
    onSubmit,   
    handlePageChange,
    pageIndex,
  } = useDeptList();

  const { watch } = methods;

  const [selectedRow, setSelectedRow] = useState("");

  const onRowClick = (deptNum) => {
    setSelectedRow((prev) => (prev === deptNum ? "" : deptNum));
  };

  const handleConfirm = (e) => {
    e.preventDefault();
    if (!selectedRow) {
      alert("선택된 담당자가 없습니다.");
      return;
    }
    const selectedUser = data.resultList.find((user) => user.deptNum === selectedRow);
    onConfirm(selectedUser);
  };

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      overlayClassName="modal-overlay2"
      className="modal-wrap"
    >
      <div className="modal-container" style={containerStyle}>
          <div className="modal-header"  style={{ cursor: "move" }}>
            <h5>담당자 선택</h5>
            <button type="button" className="modal-btn-close" onClick={onClose}>
              <span className="modal-btn-span">X</span>
            </button>
          </div>
        <FormProvider {...methods}>  
        <div className="modal-content">
          <div className="search-wrap">
            <div className="search-row">
              <div className="search-item date-picker-box">
                <label>등록일</label>
                <DateInput name="createStDate" />
                <span className="separator">~</span>
                <DateInput name="createEndDate" minDate={watch("createStDate")} />
              </div>

              <div className="search-item">
                <Select
                  name="searchCnd"
                  options={[
                    { key: "0", name: "사번" },
                    { key: "1", name: "부서" },
                    { key: "2", name: "이름" },
                  ]}
                  defaultOption="선택"
                  className="input-select"
                />
                <Input
                  name="searchWrd"
                  placeholder="검색어를 입력하세요"
                  className="input-search"
                  style={{ width: "250px" }}
                />
              </div>
              <div className="search-btn-container">
                <button type="button" className="btn-search" onClick={handleSubmit(onSubmit)} >조회</button>
              </div>
            </div>
          </div>
            <div className="modal-table-list">
            <table className="table-list" style={{ width: "100%" }}>
              <colgroup>
                <col style={{ width: "3%" }} />
                <col style={{ width: "7%" }} />
                <col style={{ width: "20%" }} />
                <col style={{ width: "20%" }} />
                <col style={{ width: "20%" }} />
              </colgroup>
              <thead>
                <tr>
                  <th></th>
                  <th>사번</th>
                  <th>부서명</th>
                  <th>이름</th>
                  <th>등록일</th>
                </tr>
              </thead>
              <tbody>
              {data?.resultList && data.resultList.length > 0 ? (
                    data.resultList.map((item) => {
                      const isChecked = selectedRow === item.deptNum;
                      return (
                        <tr
                          key={item.deptNum}
                          onClick={() => onRowClick(item.deptNum)}
                          style={{ cursor: "pointer" }}
                        >
                          <td>
                            <input type="checkbox" checked={isChecked} readOnly />
                          </td>
                          <td>{item.deptNum}</td>
                          <td>{item.deptName}</td>
                          <td>{item.name}</td>
                          <td>{item.regDate}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={5} style={{ textAlign: "center" }}>
                        조회 결과가 없습니다.
                      </td>
                    </tr>
                  )}
              </tbody>
            </table>
              {data?.paginationInfo && data.paginationInfo.totalRecordCount > 0 && (
                <Pagination
                    totalPages={Math.ceil(
                    data.paginationInfo.totalRecordCount / data.paginationInfo.recordCountPerPage
                    )}
                    currentPage={pageIndex}
                    onPageChange={handlePageChange}
                    pageRangeDisplayed={5}
                />
              )}
          </div>
        </div>

        </FormProvider>
        <div className="modal-btn-wrap btn-right-box" style={{marginTop:'20px'}}>
            <ul>
                <li><button type="button" className="btn-cancel" onClick={onClose}>취소</button></li>
                <li><a href="/" title="저장" className="btn-save" onClick={handleConfirm}>확인</a></li>
            </ul>
        </div>
      </div>
    </ReactModal>
  );
}

export {SearchUserModal};
